module.exports = __webpack_public_path__ + "static/media/COS_NATIVE.815e1983.webp";